import React from 'react';
import { Modal, Typography, Button } from 'antd';
import { RefundRequest } from './index';

type RefundStatus = 'PENDING' | 'APPROVED' | 'REJECTED' | 'REFUNDED';

interface RefundRequestModalProps {
  open: boolean;
  onClose: () => void;
  refundRequest: RefundRequest | null;
  onStatusUpdate: (status: RefundStatus) => void;
}

const RefundRequestModal: React.FC<RefundRequestModalProps> = ({
  open,
  onClose,
  refundRequest,
  onStatusUpdate,
}) => {
  if (!refundRequest) return null;

  const handleStatusUpdate = (status: RefundStatus) => {
    onStatusUpdate(status);
    onClose();
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={600}
      title={refundRequest.orderId}
      aria-labelledby="refund-request-modal"
      aria-describedby="refund-request-details"
    >
      <div style={{ padding: '20px' }}>
        <Typography.Title level={5}>Refund Request Details</Typography.Title>
        <div style={{ marginBottom: '20px' }}>
          <Typography.Text strong>Order ID: </Typography.Text>
          <Typography.Text>{refundRequest.orderId}</Typography.Text>
        </div>
        <div style={{ marginBottom: '20px' }}>
          <Typography.Text strong>Amount: </Typography.Text>
          <Typography.Text>
            ${refundRequest.refundDetails?.refundAmount?.toFixed(2) || '0.00'}
          </Typography.Text>
        </div>
        <div style={{ marginBottom: '20px' }}>
          <Typography.Text strong>Customer Name: </Typography.Text>
          <Typography.Text>{refundRequest.name}</Typography.Text>
        </div>
        <div style={{ marginBottom: '20px' }}>
          <Typography.Text strong>Status: </Typography.Text>
          <Typography.Text
            style={{
              color:
                refundRequest.status === 'APPROVED'
                  ? 'success.main'
                  : refundRequest.status === 'REJECTED'
                    ? 'error.main'
                    : refundRequest.status === 'PENDING'
                      ? 'warning.main'
                      : 'text.primary',
            }}
          >
            {refundRequest.status.charAt(0).toUpperCase() + refundRequest.status.slice(1)}
          </Typography.Text>
        </div>
        <div style={{ marginBottom: '20px' }}>
          <Typography.Text strong>Reason: </Typography.Text>
          <Typography.Text>{refundRequest.refundReason}</Typography.Text>
        </div>

        {refundRequest.status === 'PENDING' && (
          <div
            style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' }}
          >
            <Button type="primary" danger onClick={() => handleStatusUpdate('REJECTED')}>
              Reject
            </Button>
            <Button type="primary" onClick={() => handleStatusUpdate('APPROVED')}>
              Approve
            </Button>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default RefundRequestModal;
